import $ from 'jquery';

$(() => {
  const footerBottomStuck = () => {
    const wrapHeight = $('.wrap').height();
    if (wrapHeight < $(window).height()) {
      $('footer.main-foot').addClass('bottom-stuck');
    } else {
      $('footer.main-foot').removeClass('bottom-stuck');
    }
  };

  footerBottomStuck();

  $('.remove-item').on('click', () => {
    footerBottomStuck();
  });
});



/** WEBPACK FOOTER **
 ** ./src/js/footer-bottom-stick.js
 **/